import React from 'react'
import { Fab } from '@mui/material'
import { KeyboardArrowRight } from '@mui/icons-material'
import { putAwayActions } from '../../actions/putAwayActions'
import { usePutAway } from '../../Context/usePutAway'

export default function FlipButtonBack() {
  const { state, dispatch } = usePutAway()
  const { isFlipped: flippState } = state
  const { setIsFlipped } = putAwayActions()

  return (
    <Fab
      onClick={() => dispatch(setIsFlipped(false, 99))}
      aria-label='NotView'
      style={{
        position: 'absolute',
        borderRadius: '50%',
        height: '40px',
        width: '40px',
        minWidth: '40px',
        minHeight: '40px',
        zIndex: 1,
        right: 0,
        visibility: flippState.isFlipped ? 'visible' : 'hidden'
      }}
    >
      <KeyboardArrowRight />
    </Fab>
  )
}
